import React, { useRef } from 'react';
import { bool, func, string } from 'prop-types';
import { Form as FinalForm, Field } from 'react-final-form';
import classNames from 'classnames';

import { Form } from '../../../../components';
import IconSearchDesktop from './IconSearchDesktop';
import css from './TopbarSearchForm.module.css';

const KeywordSearchField = props => {
  const { keywordSearchWrapperClasses, iconClass, isMobile, inputRef } = props;
  return (
    <div className={keywordSearchWrapperClasses}>
      <button className={css.searchSubmit}>
        <div className={iconClass}>
          <IconSearchDesktop />
        </div>
      </button>
      <Field
        name="keywords"
        render={({ input, _meta }) => {
          return (
            <input
              className={isMobile ? css.mobileInput : css.desktopInput}
              {...input}
              id={isMobile ? 'keyword-search-mobile' : 'keyword-search'}
              data-testid={isMobile ? 'keyword-search-mobile' : 'keyword-search'}
              ref={inputRef}
              type="text"
              placeholder="Search by keyword..."
              autoComplete="off"
            />
          );
        }}
      />
    </div>
  );
};

function TopbarSearchFormComponent({
  rootClassName = null,
  className = null,
  desktopInputRoot = null,
  isMobile = false,
  ...props
}) {
  const searchInput = useRef(null);

  const onSubmit = values => {
    props.onSubmit({ keywords: values.keywords });
    searchInput.current?.blur();
  };

  return (
    <FinalForm
      rootClassName={rootClassName}
      className={className}
      desktopInputRoot={desktopInputRoot}
      isMobile={isMobile}
      {...props}
      onSubmit={onSubmit}
      render={formRenderProps => {
        const {
          rootClassName,
          className,
          desktopInputRoot,
          isMobile,
          handleSubmit,
        } = formRenderProps;
        const classes = classNames(rootClassName, className);
        const desktopInputRootClass = desktopInputRoot || css.desktopInputRoot;
        const keywordSearchWrapperClasses = classNames(
          css.keywordSearchWrapper,
          isMobile ? css.mobileInputRoot : desktopInputRootClass
        );
        return (
          <Form className={classes} onSubmit={handleSubmit} enforcePagePreloadFor="SearchPage">
            <KeywordSearchField
              keywordSearchWrapperClasses={keywordSearchWrapperClasses}
              iconClass={classNames(isMobile ? css.mobileIcon : css.desktopIcon || css.icon)}
              isMobile={isMobile}
              inputRef={searchInput}
            />
          </Form>
        );
      }}
    />
  );
}



TopbarSearchFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  desktopInputRoot: string,
  onSubmit: func.isRequired,
  isMobile: bool,
};

export default TopbarSearchFormComponent;
